import {
  toNio,
  toUSD,
  toGTQ,
  toEUR,
  toGBP,
  toUSDSimpleFormat,
  toNioSimpleFormat,
  toGTQSimpleFormat,
  toEURSimpleFormat,
  toGBPSimpleFormat,
  toAUD,
  toCAD,
  toDKK,
  toAED,
  toCHF,
  toNOK,
  toNZD,
  toPLN,
  toCZK,
  toRON,
  toSGD,
  toSEK,
  toAUDSimpleFormat,
  toCADSimpleFormat,
  toDKKSimpleFormat,
  toAEDSimpleFormat,
  toCHFSimpleFormat,
  toNOKSimpleFormat,
  toNZDSimpleFormat,
  toPLNSimpleFormat,
  toCZKSimpleFormat,
  toRONSimpleFormat,
  toSGDSimpleFormat,
  toSEKSimpleFormat,
} from '@/utils/formatters/currencyFormat'

export * from './remittance'
export * from './customer'
export * from './environment'
export * from './cashCount'
export * from './admin'

export const userStorageKey = '__loggedInUser__'
export const denominationsStorageKey = '__denominations__'
export const permissionStorageKey = '__aclService__'
export const adminPassword = '1234'
export const emailRegExp = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/

export const currencyNameMapper = {
  USD: 'Dólar',
  NIO: 'Córdoba',
  GTQ: 'Quetzal',
}

export const currencyMethodMapper = {
  USD: toUSD,
  NIO: toNio,
  GTQ: toGTQ,
  EUR: toEUR,
  GBP: toGBP,
  AUD: toAUD,
  CAD: toCAD,
  DKK: toDKK,
  AED: toAED,
  CHf: toCHF,
  NOK: toNOK,
  NZD: toNZD,
  PLN: toPLN,
  CZK: toCZK,
  RON: toRON,
  SGD: toSGD,
  SEK: toSEK,
}

export const currencySimpleMapper = {
  USD: toUSDSimpleFormat,
  NIO: toNioSimpleFormat,
  GTQ: toGTQSimpleFormat,
  EUR: toEURSimpleFormat,
  GBP: toGBPSimpleFormat,
  AUD: toAUDSimpleFormat,
  CAD: toCADSimpleFormat,
  DKK: toDKKSimpleFormat,
  AED: toAEDSimpleFormat,
  CHf: toCHFSimpleFormat,
  NOK: toNOKSimpleFormat,
  NZD: toNZDSimpleFormat,
  PLN: toPLNSimpleFormat,
  CZK: toCZKSimpleFormat,
  RON: toRONSimpleFormat,
  SGD: toSGDSimpleFormat,
  SEK: toSEKSimpleFormat,
}

export const permissionEnum = {
  0: 'CanView',
  1: 'CanAdd',
  2: 'CanChange',
  3: 'CanDelete',
}
